import { useCallback } from "react";
import { Seo } from "../components/Seo";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Screenshots } from "../components/Screenshots";
import { Steps } from "../components/Steps";
import { PrivacyPanel } from "../components/PrivacyPanel";
import { Faq } from "../components/Faq";
import { AppCallout } from "../components/AppCallout";
import { SmartAppBanner } from "../components/SmartAppBanner";
import { Footer } from "../components/Footer";

export default function Landing() {
  const scrollTo = useCallback((id) => {
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div data-testid="landing" id="top" className="min-h-screen bg-ink text-paper">
      <Seo title="Home" path="/" />
      <Header onNav={scrollTo} onGetApp={() => scrollTo("download")} />
      <main>
        <Hero onPreview={() => scrollTo("screenshots")} />
        <Marquee />
        <Screenshots />
        <Steps />
        <PrivacyPanel />
        <Faq />
        <AppCallout />
      </main>
      <Footer />
      <SmartAppBanner onGetApp={() => scrollTo("download")} />
    </div>
  );
}
